/* eslint-disable react/prop-types */
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { FormControl, FormSelect, InputGroup } from "react-bootstrap";
import useParamsHandler from "../../../utils/hooks/useParamsHandler";

import Flex from "../Flex";

const AdvanceTableSearchBox = ({
  placeholder = "Search...",
  filter,
  searchQuery,
  userTypeQuery,
  statusQuery,
}) => {
  const [value, setValue] = useState(searchQuery);

  const { searchParamsHandler } = useParamsHandler();

  return (
    <Flex>
      {filter.includes("userType") && (
        <FormSelect
          className="mx-1"
          aria-label="User Type"
          placeholder="User Type"
          size="sm"
          value={userTypeQuery}
          onChange={(e) => {
            searchParamsHandler("userType", e.target.value);

            // setPage(1);
            // setUserTypeQuery(e.target.value);
            // setStatusQuery("");
            // setSearchQuery("");
            // setSortQuery({
            // 	column: "createdOn",
            // 	order: "desc",
            // });
          }}>
          <option value="">User Type</option>
          <option value="g-user">General</option>
          <option value="b-user">Business</option>
          <option value="c-user">Charity</option>
          <option value="admin">Admin</option>
        </FormSelect>
      )}
      {filter.includes("status") && (
        <FormSelect
          className="mx-1"
          aria-label="status"
          placeholder="status"
          size="sm"
          value={statusQuery}
          onChange={(e) => {
            searchParamsHandler("status", e.target.value);

            // setPage(1);
            // setStatusQuery(e.target.value);
            // setSearchQuery("");
            // setUserTypeQuery("");
          }}>
          <option value="">Status</option>
          <option value="Active">Active</option>
          <option value="Archived">Archived</option>
          <option value="Disabled">Disabled</option>
        </FormSelect>
      )}
      <InputGroup className="position-relative mx-1">
        <FormControl
          value={value || ""}
          onKeyPress={(e) => {
            if (e.key === "Enter") {
              searchParamsHandler("search", value);

              // setPage(1);
              // setSearchQuery(value);
              // setUserTypeQuery("");
              // setStatusQuery("");

              // setSortQuery({
              //   column: "createdOn",
              //   order: "desc",
              // });
            }
          }}
          onChange={(e) => {
            setValue(e.target.value);
            if (e.target.value === "") {
              // setSearchQuery("");
              searchParamsHandler("search", "");
            }
          }}
          size="sm"
          id="search"
          placeholder={placeholder}
          type="search"
          className="shadow-none"
        />
        <InputGroup.Text className="bg-transparent cursor-pointer">
          <FontAwesomeIcon
            onClick={() => {
              searchParamsHandler("search", value);
              // setPage(1);
              // setSearchQuery(value);
              // setUserTypeQuery("");
              // setStatusQuery("");
              // setSortQuery({
              //   column: "createdOn",
              //   order: "desc",
              // });
            }}
            icon={faSearch}
            className="fs--1 text-600"
          />
        </InputGroup.Text>
      </InputGroup>
    </Flex>
  );
};

export default AdvanceTableSearchBox;
